import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import RankingSection from './components/RankingSection';

const siteUrl = 'https://www.hanman.com';
const siteTitle = '韩漫网-免费韩国漫画大全-海量正版漫画在线阅读';
const siteDesc = '韩漫网为您提供海量正版韩国漫画免费在线阅读，资源齐全且画质精良，支持多设备无缝切换，是您随时随地享受阅读乐趣的首选平台。';
const siteKeywords = '韩漫网,免费韩国漫画,海量正版漫画,在线阅读';
const ogImage = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20platform%20homepage%2C%20colorful%20comic%20covers%20arranged%20in%20grid%2C%20warm%20inviting%20atmosphere%2C%20clean%20modern%20design%2C%20reading%20theme%2C%20Korean%20style%20illustration&width=1200&height=630&seq=og-home-01&orientation=landscape';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫网',
  url: siteUrl,
  description: siteDesc,
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@hanman.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫网',
  url: siteUrl,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/category/all?search={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: siteTitle,
  description: siteDesc,
  url: siteUrl,
  isPartOf: {
    '@type': 'WebSite',
    name: '韩漫网',
    url: siteUrl,
  },
  about: {
    '@type': 'Organization',
    name: '韩漫网',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title={siteTitle}
        description={siteDesc}
        keywords={siteKeywords}
        canonicalUrl={siteUrl}
        ogImage={ogImage}
        schemaData={{ ...organizationSchema, ...websiteSchema, ...homeSchema }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedComics />
        <LatestUpdates />
        <RankingSection />

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="bg-primary-500 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              开始你的漫画之旅
            </h2>
            <p className="text-background-50/80 max-w-lg mx-auto mb-6 text-sm md:text-base">
              加入韩漫网，发现更多精彩韩国漫画。海量正版资源免费阅读，随时随地享受阅读乐趣。
            </p>
            <a
              href="/category/all"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 text-primary-500 rounded-full text-sm font-semibold hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
            >
              浏览全部漫画
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}